import React, { useEffect, useState } from "react";
import { teksAPI } from "../services/api";
import TEKSModal from "../components/TEKSModal";

const TeksPage = ({ courseId }) => {
  const [standards, setStandards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTeksCode, setSelectedTeksCode] = useState(null);

  useEffect(() => {
    if (!courseId) {
      setStandards([]);
      return;
    }

    const loadStandards = async () => {
      setLoading(true);
      try {
        const response = await teksAPI.getAll(courseId);
        setStandards(response.data || []);
      } catch (error) {
        console.error("Error loading TEKS standards:", error);
      } finally {
        setLoading(false);
      }
    };

    loadStandards();
  }, [courseId]);

  if (!courseId) {
    return (
      <div className="panel-card" data-tour="teks-list">
        <h2>TEKS Standards</h2>
        <p>Select a course to view standards.</p>
      </div>
    );
  }

  return (
    <>
      <div className="panel-card">
        <h2>TEKS Standards</h2>
        {loading && <p>Loading standards...</p>}
        {!loading && standards.length === 0 && <p>No standards found for this course.</p>}
        {!loading && standards.length > 0 && (
          <div className="simple-list">
            {standards.map((teks) => (
              <div key={teks.id} className="simple-item row">
                <div>
                  <h3>{teks.teks_code}</h3>
                  <p>{teks.description}</p>
                  <p>
                    <strong>{teks.category}</strong> | CBA weight: {teks.cba_item_weight}
                  </p>
                </div>
                  <button
                    className="primary-btn"
                    data-tour="teks-profile-btn"
                    onClick={() => setSelectedTeksCode(teks.teks_code)}
                  >
                  View Profile
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedTeksCode && (
        <TEKSModal
          teksCode={selectedTeksCode}
          courseId={courseId}
          onClose={() => setSelectedTeksCode(null)}
        />
      )}
    </>
  );
};

export default TeksPage;
